import React from 'react';

import BREAKPOINT from 'src/shared/config/Breakpoint';
import NewsPreview from 'src/components/NewsPreview';
import ArticlePostModel from 'src/types/article/ArticlePostModel';

import FeaturedFromOthersCards from '../FeaturedFromOtherCards';
import styles from './styles.module.scss';

export interface ItemType {
    type: 'featured' | 'normal' | 'featuredFromOthersCards' | 'featuredFromOthers';
    item?: ArticlePostModel | null;
    items?: ArticlePostModel[];
}

interface ListItemProps {
    className?: string;
    type?: 'normal' | 'pinned' | 'featuredFromOthers' | 'featuredFromOthersCards';
    item?: ArticlePostModel;
    items?: ArticlePostModel[];
    screenWidth: number;
}

const ListItem = ({ className, type, item, items, screenWidth }: ListItemProps) => {
    if (!item && !items) {
        return null;
    }

    return (
        <div className={`${styles.container} ${className}`}>
            {type === 'pinned' && <NewsPreview className={styles.cardItem} item={item} type="column_wide" shouldShowFeaturedOverCategory />}
            {type === 'normal' && (
                <NewsPreview
                    className={styles.listItem}
                    item={item}
                    type={screenWidth > BREAKPOINT.MD ? 'row_left-img' : 'row_right-img'}
                    shouldShowLabel={false}
                />
            )}
            {type === 'featuredFromOthersCards' && <FeaturedFromOthersCards items={items} isInList />}
            {type === 'featuredFromOthers' && <NewsPreview className={styles.cardItem} item={item} type="column_normal" />}
        </div>
    );
};

ListItem.defaultProps = {
    className: '',
    type: 'normal',
    item: null,
    items: null,
};

export default ListItem;
